import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

export const uploadLogo = async (
    environmentId: string,
    tenantId: string,
    name: string,
    file: File | null
): Promise<[void | null, number]> => {
    if (!environmentId) {
        return defaultErrorResponse;
    }

    const response = await API.post(
        `/environments/${environmentId}/tenants/${tenantId}/logo/${encodeURIComponent(name)}`,
        file
    );

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};
